import { render, staticRenderFns } from "./worldmap.vue?vue&type=template&id=9db48c88&scoped=true&"
import script from "./worldmap.vue?vue&type=script&lang=js&"
export * from "./worldmap.vue?vue&type=script&lang=js&"
import style0 from "./worldmap.vue?vue&type=style&index=0&id=9db48c88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db48c88",
  null
  
)

export default component.exports